import { ModalWindow, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { ProgramContent } from './components';
import { IMortgageProgramModal } from './types';
import { MORTGAGE_LINK } from '../../../../constants/mortgage';

export const MortgageProgramModalMobile: React.FC<IMortgageProgramModal> = ({
  name,
  onClose,
  onMortgageButtonClick,
  ...selectedProgram
}) => {
  return (
    <ModalWindow
      open
      title={`Программа ипотеки «${name}»`}
      fixed
      footer={
        <LinkButton
          size="L"
          theme="fill_primary"
          fullWidth
          href={MORTGAGE_LINK}
          onClick={() => onMortgageButtonClick(selectedProgram.id)}
        >
          Подать заявку онлайн
        </LinkButton>
      }
      onClose={onClose}
      content={<ProgramContent {...selectedProgram} />}
    />
  );
};
